/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'receipt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(9 7)" _stroke="#00272E"><g transform="translate(2.625 8.773)" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M0 .432h5.25"/><path pid="1" d="M0 3.023h3.5"/><path pid="2" d="M0 5.614h4.375"/><path pid="3" d="M7.875.432h.875"/><path pid="4" d="M7.875 3.023h.875"/><path pid="5" d="M7.875 5.614h.875"/></g><rect pid="6" x="0" y="0" width="14" height="19" rx=".855"/><path pid="7" d="M2.8 3.714h3.733" stroke-linecap="round" stroke-linejoin="round"/><path pid="8" d="M2.8 5.483h2.625" stroke-linecap="round" stroke-linejoin="round"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/receipt.js